import { addressResponseType } from '@utils';

export const CustomAddressContent = ({
  locationTitle,
  selectedAddress,
}: {
  locationTitle: string;
  selectedAddress: addressResponseType;
}) => {
  return selectedAddress && selectedAddress.full_address ? (
    <div className="flex flex-col gap-2">
      <p className="text-bodyLg font-semibold">{locationTitle}</p>
      <p className="text-bodyLg font-normal">{selectedAddress.full_address}</p>
    </div>
  ) : null;
};
